import React from "react";
import { Box, Grid, LinearProgress, Typography } from "@mui/material";
import KitchenItemSummary from "../../order/component/KitchenItemSummary";
import { getProgressLane, getStartTime } from "../../common/util";

function sortByFulfillmentTime(a, b) {
  return getStartTime(a.fulfillment?.time) - getStartTime(b.fulfillment?.time);
}

export default function KitchenItemSwimLanes(props) {
  const { items, onItemProgressChange, onItemSelect } = props;

  let notStarted = [];
  let inProgress = [];
  let completed = [];

  for (const item of items) {
    const lane = getProgressLane(item.progress);
    if (lane === "completed") {
      completed.push(item);
    } else if (lane === "inProgress") {
      inProgress.push(item);
    } else {
      notStarted.push(item);
    }
  }

  notStarted.sort(sortByFulfillmentTime);
  inProgress.sort(sortByFulfillmentTime);
  completed.sort(sortByFulfillmentTime);

  const lanes = [
    { title: "Not Started", items: notStarted, color: "#e74c3c" },
    { title: "In-Progress", items: inProgress, color: "#fdcb6e" },
    { title: "Completed", items: completed, color: "#00b894" },
  ];

  return (
    <Box>
      <Box my={4}>
        <Grid container spacing={2}>
          {lanes.map((lane) => (
            <Grid item sm={4} key={lane.title}>
              <Typography variant="subtitle1" gutterBottom>
                {lane.title} ({lane.items.length})
              </Typography>
              <Box sx={{ color: lane.color }}>
                <LinearProgress variant="determinate" value={100} color="inherit" />
              </Box>
              {lane.items.map((item) => (
                <Box key={`${item.orderId}-${item.itemIndex}`} my={2}>
                  <KitchenItemSummary
                    item={item}
                    onProgressChange={onItemProgressChange}
                    onItemSelect={onItemSelect}
                  />
                </Box>
              ))}
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}
